export enum ObjectFitEnum {
  COVER,
  CONTAIN,
}
